import {
  useDebouncedState,
  useErrorToast,
  useSuccessToast
} from '@react/lib/hooks';
import ReportsTable from './reports';
import { flatMap } from 'lodash';
import React, { FunctionComponent, useMemo, useState } from 'react';
import { useReportsQuery } from './hooks';

const Reports: FunctionComponent = () => {
  // TODO: Make reports searchable
  const [searchInputValue, setSearchInputValue] = useState('');
  const [filters, setFilters] = useState({});
  const searchTerm = useDebouncedState(searchInputValue, 500);

  const {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isError
  } = useReportsQuery({ searchTerm, filters });

  const onScrollToEnd = () => {
    const shouldFetchNextPage =
      hasNextPage && !isLoading && !isFetchingNextPage;
    if (shouldFetchNextPage) {
      fetchNextPage();
    }
  };

  const loading = isLoading || isFetchingNextPage;
  const reports = useMemo(
    () => data && data.pages && flatMap(data.pages, (page) => page.data),
    [data]
  );

  // TODO: localisation
  useErrorToast(isError, {
    title: 'Error',
    message: 'Failed to load reports'
  });

  return (
    <>
      {reports && reports.length > 0 && (
        <ReportsTable
          data={reports}
          loading={loading}
          onScrollToEnd={onScrollToEnd}
        />
      )}
    </>
  );
};

export default Reports;
